import { api } from '@/shared/api/client';
import type {
  PatchUsersMeRequest,
  PatchUsersMeResponse,
} from '../model/dto';

export const patchUsersMe = async (payload: PatchUsersMeRequest) => {
  const { data } = await api.patch<PatchUsersMeResponse>(
    '/users/me/',
    payload
  );
  return data;
};
